<template>
  <div>
    <v-layout v-if="!doShowSber">
      <v-container>
        <v-flex style="margin-top: 10px">
          <v-card color="card">
            <v-card-text row v-if="payOptions && payOptions.length > 0">
              <v-flex xs12 class="mb-5">
                Платежи с дебетовых или кредитных карт любого банка.
                Оплата производится без комиссии.
              </v-flex>

              <v-flex xs12 text-left>
                <v-text-field
                  outlined
                  v-model="amount"
                  v-mask="'####'"
                  append-icon="mdi-currency-rub"
                  :rules="[rules.minValue]"
                  @keyup.enter="payByBankCard"
                >
                  <template v-slot:label>
                  <span>
                    Сумма платежа <b>*</b>
                  </span>
                  </template>
                </v-text-field>

                <v-checkbox label="Отправить чек" color="primary" v-model="showEmailInput"></v-checkbox>

                <v-text-field
                  v-show="showEmailInput"
                  outlined
                  v-model="email"
                  type="email"
                  :rules="[rules.email]"
                  autofocus
                  hint="На этот E-mail будет отправлен чек"
                >
                  <template v-slot:label>
                    <span>E-mail</span>
                  </template>
                </v-text-field>
              </v-flex>

            </v-card-text>

            <v-card-actions :class="[viewport === 'xs' || viewport === 'sm' ? 'buttons-col' : 'buttons-row']">
              <v-spacer v-if="!(viewport === 'xs' || viewport === 'sm')"></v-spacer>

              <sbp-payment
                class="mr-2"
                :personal-account="+uid"
                :email="email"
                :amount="+amount"
                :disabled="isDisabledPayment"
              />

              <v-btn
                color="success"
                @click="payByBankCard"
                :disabled="isDisabledPayment"
              >
                Оплатить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-container>
    </v-layout>

    <v-layout row v-else>
      <v-container>
        <v-container>
          <v-flex style="margin-top: 10px">
            <v-card color="card">
              <v-card-text row>
                <v-flex xs12 v-html="sberOnlineData.data.info"></v-flex>
              </v-card-text>
              <v-card-actions style="margin-top: -15px;">
                <v-btn color="primary" v-on:click="$emit('backToMain')">
                  Назад
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-container>
      </v-container>
    </v-layout>

    <v-snackbar v-model="paymentError">Не удалось произвести пополнение баланса</v-snackbar>
  </div>
</template>

<script>
import axios from 'axios';
import SbpPayment from "./Payments/SbpPayment.vue";

const emailRegExp = /.+\@.+\..+/;

export default {
  name: 'PayHandlerComponent',
  components: {SbpPayment},
  props: ['uid', 'doShowSber'],
  data() {
    return {
      payOptions: undefined,
      amount: 500,
      email: null,
      toBeBound: true,
      isOnLoad: false,
      sberOnlineData: null,
      showEmailInput: false,
      paymentError: false,
      rules: {
        minValue: value => +value >= 150 || 'Минимальная сумма платежа - 150 &#8381',
        email: value => !value || emailRegExp.test(value) || 'Не верный E-mail',
        required: value => !!value || 'Поле обязательно к заполнению',
      },
    };
  },
  created() {
    this.getPayOptions();
  },

  computed: {
    viewport() {
      return this.$vuetify.breakpoint.name;
    },

    isDisabledPayment() {
      return this.amount < 150
        || this.isOnLoad
        || (this.email && !emailRegExp.test(email))
        ;
    },

    personalAccount() {
      return parseInt(this.uid);
    },
  },

  methods: {
    toggleLoading() {
      this.isOnLoad = !this.isOnLoad;
      this.$emit('loading-toggled');
    },

    getPayOptions() {
      this.toggleLoading();
      axios(process.env.REST_SERVICE + `/payments/by-personal-account/${this.personalAccount}`).then(response => {
        this.toggleLoading();
        this.payOptions = response.data.data;
      });
    },

    payByBankCard() {
      if (this.amount < 150) {
        return;
      }

      this.toggleLoading();

      axios.post(`${process.env.ACQUIRING_API}/payments/for-personal-account/${this.personalAccount}`, {
        data: {
          sum: this.amount,
          email: this.email,
          return_url: `${process.env.BASE_URL}/success/`,
        }
      }).then((response) => {
        window.location.href = response.data.data.confirmation_url;
      }).catch(() => {
        this.paymentError = true;
      }).finally(() => {
        this.toggleLoading();
      });
    },
  },
};
</script>

<style scoped>

.v-checkbox label {
  font-size: 8px;
}

</style>




// WEBPACK FOOTER //
// src/components/PayHandlerComponent.vue